import { InitialState } from '../initialState';
import { RootAction } from '../actions';
import { LoginCountActions } from '../actions/LoginCountActions';
import { getType } from 'typesafe-actions';

export const loginCountReducer = (state = InitialState.loginCount, action: RootAction) => {
  switch (action.type) {
    case getType(LoginCountActions.receivedLoginCount): {
      return {
        ...state,
        loginCount: action.payload.loginCount,
      };
    }
    default:
      return state;
  }
};
